<template>
    <div class="mb-8 space-y-2 max-w-7xl mx-auto">
        <div class="flex items-center justify-between bg-gray-50 py-2 px-3">
            <h4 class="text-lg text-center font-medium">{{ $t('Comments') }}</h4>
        </div>

        <ul class="space-y-1">
            <li v-for="comment in comments" :key="comment.id">
                <CommentCard :comment="comment" />
            </li>
        </ul>

        <spinner v-if="loading" />
        <div v-else>
            <div v-if="hasMore" class="flex justify-center">
                <button
                    @click="showMore"
                    class="border flex justify-center items-center h-10 w-40 border-gray-400 hover:border-gray-800 text-sm rounded px-3 py-2"
                >
                    <spinner v-if="loadingMore" class="text-white" />
                    <span v-else>{{ $t('Load More') }}</span>
                </button>
            </div>
            <div v-else class="flex justify-center">
                <span>{{ $t('No more items to show') }}</span>
            </div>
        </div>
    </div>
</template>
<script>
import api from '../lib/api'
import CommentCard from '../components/CommentCard'

export default {
    components: {
        CommentCard,
    },
    methods: {
        async showMore() {
            this.loadingMore = true
            try {
                const [moreComments, newOffset] = await api.getComments(this.limit, this.offset)
                this.comments = [...this.comments, ...moreComments]
                this.offset = newOffset
                this.loadingMore = false
            } catch (err) {
                console.log('Err:', err)
            }
        },
    },
    data() {
        return {
            comments: null,
            loading: true,
            loadingMore: false,
            limit: 10,
            offset: null,
            hasMore: true,
        }
    },
    async mounted() {
        if (this.$route.query.reload === true) {
            this.$router.push('/comments')
        }
        try {
            const [comments, newOffset] = await api.getComments(this.limit, null)
            this.comments = comments
            this.offset = newOffset
            this.loading = false
        } catch (err) {
            console.log('Err:', err)
        }
    },
}
</script>
